import React from 'react';
import {observer} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import Translate from '../translate/Translate';
import './video-pause.style.scss';

interface VideoPauseProps {
    shouldDisplayPause: boolean;
    pauseVideo: (event?: React.MouseEvent) => void;
    videoPausedByDashboard: boolean;
    stretchedVideoMode: boolean;
    roundedFloatingVideo: boolean;
    squareFloatingVideo: boolean;
    requiredImage: (imageName: string) => string;
}

@observer
export class VideoPause extends TechseeBaseComponent<VideoPauseProps> {
    renderInternal(): JSX.Element {
        const {
            shouldDisplayPause,
            pauseVideo,
            videoPausedByDashboard,
            stretchedVideoMode,
            roundedFloatingVideo,
            squareFloatingVideo,
            requiredImage
        } = this.props;

        const shouldDisplay =
            shouldDisplayPause && (!stretchedVideoMode || (!roundedFloatingVideo && !squareFloatingVideo));

        if (!shouldDisplay) {
            return <></>;
        }

        return (
            <div className='dashboard-main-pause-container'>
                <div className='dashboard-main-pause-live-container'>
                    <div
                        className={`dashboard-main-pause-live-message ${videoPausedByDashboard ? 'paused' : ''}`}
                        onClick={pauseVideo}>
                        <span>
                            <Translate text='MAIN.VIEW.LIVE' />
                        </span>
                    </div>
                    {videoPausedByDashboard && (
                        <div className='dashboard-main-pause-live-paused'>
                            <Translate text='MAIN.VIEW.PAUSED' />
                        </div>
                    )}
                </div>

                <div className='dashboard-main-pause-button' onClick={pauseVideo}>
                    <img
                        src={
                            videoPausedByDashboard ? requiredImage('play-video.png') : requiredImage('pause-video.png')
                        }
                        alt={videoPausedByDashboard ? 'Play' : 'Pause'}
                    />
                </div>
            </div>
        );
    }
}
